Object.defineProperty(exports, '__esModule', { value: true });

var components_arrow_Component = require('./Component.js');
require('react');
require('classnames');
require('@alfalab/icons-glyph/ChevronDownMIcon');



exports.Arrow = components_arrow_Component.Arrow;
